<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <span>구매취소되었습니다</span>
                </div>
            </div>
          <div class="button-wrap">
<!--            <button class="button-bg-gray" @click="$router.replace({ path: '/myemarticon/savebox' });">닫기</button>-->
            <button class="button-bg-gray" @click="$router.go(-2);">닫기</button>
          </div>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'PaymentVoidPopup',
    components: {BottomButton},
    data() {
        return  {
        }
    },
    methods : {
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/paymentVoidPopup.scss';
</style>